import React, { useState } from "react";
import Modal from "@mui/material/Modal";
import { RxCross1 } from "react-icons/rx";
import { ReactComponent as ImportIcon } from "../../assets/icons/import.svg";
import { useFormik } from "formik";
import * as Yup from "yup";
import { toast } from "react-toastify";

const RoomLogImportModal = ({ open, onClose, onImport }) => {
  const [selectedFile, setSelectedFile] = useState(null);
  const [isDragging, setIsDragging] = useState(false);
  const fileInputRef = React.useRef(null);

  const handleFileChange = (e) => {
    const file = e.target.files && e.target.files[0] ? e.target.files[0] : null;
    if (file) {
      setSelectedFile(file);
      importFormik.setFieldValue("file", file);
    }
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(true);
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(false);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(false);

    const file =
      e.dataTransfer.files && e.dataTransfer.files[0]
        ? e.dataTransfer.files[0]
        : null;
    if (file) {
      setSelectedFile(file);
      importFormik.setFieldValue("file", file);
    }
  };

  const handleCancel = () => {
    setSelectedFile(null);
    importFormik.resetForm();
    onClose();
  };

  const importValidationSchema = Yup.object({
    file: Yup.mixed()
      .required("Please select a file")
      .test(
        "fileType",
        "Only Excel files (.xlsx, .xls) are allowed",
        (value) => {
          if (!value) return false;
          const allowedTypes = [
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            "application/vnd.ms-excel",
          ];
          return allowedTypes.includes(value.type);
        },
      ),
  });

  const importFormik = useFormik({
    initialValues: {
      file: null,
    },
    validationSchema: importValidationSchema,
    onSubmit: async (values) => {
      try {
        await onImport(values.file);
        setSelectedFile(null);
        importFormik.resetForm();
        onClose();
      } catch (error) {
        toast.error("Import failed. Please try again.");
      }
    },
  });

  return (
    <Modal
      open={open}
      onClose={handleCancel}
      aria-labelledby="import-modal-title"
      aria-describedby="import-modal-description"
      className="department-modal"
    >
      <div className="modal_block">
        <div className="modal_header">
          <div className="modal_title_wrapper">
            <h2 className="modal_title">Import File</h2>
          </div>
          <div className="cancel-btn-wrap" style={{ fontSize: "24px" }}>
            <RxCross1 onClick={handleCancel} />
          </div>
        </div>
        <div className="modal_content">
          <div style={{ fontSize: 12, color: "#333533" }}>Attached</div>
          <form onSubmit={importFormik.handleSubmit}>
            <div className="form_field_wrapper">
              <div
                style={{
                  border: isDragging
                    ? "2px dashed #00A272"
                    : "2px dashed #C0C0C0",
                  borderRadius: 8,
                  padding: "22px 16px",
                  textAlign: "center",
                  cursor: "pointer",
                  background: isDragging ? "#e6f6f1" : "#fafafa",
                  minHeight: 77,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
                onClick={() => fileInputRef.current?.click()}
                onDragOver={handleDragOver}
                onDragLeave={handleDragLeave}
                onDrop={handleDrop}
              >
                {!selectedFile ? (
                  <>
                    <div>
                      <ImportIcon />
                    </div>
                    <div
                      style={{
                        fontSize: 17,
                        color: "#3e3c3c",
                        fontWeight: 500,
                        margin: 4,
                      }}
                    >
                      Upload File
                    </div>
                    {/* <div style={{ fontSize: 12, color: "#999" }}>
                      Drag & drop or click to browse, Excel files only (.xlsx, .xls)
                    </div> */}
                  </>
                ) : (
                  <>
                    <div>
                      <ImportIcon />
                    </div>
                    <div
                      style={{
                        fontSize: 16,
                        color: "#00A272",
                        fontWeight: 600,
                        marginBottom: 4,
                      }}
                    >
                      {selectedFile.name}
                    </div>
                    {/* <div style={{ fontSize: 12, color: "#666" }}>
                      Click to change file
                    </div> */}
                  </>
                )}
                <input
                  ref={fileInputRef}
                  type="file"
                  accept=".xlsx,.xls"
                  style={{ display: "none" }}
                  onChange={handleFileChange}
                />
              </div>
              {importFormik.errors.file && (
                <div
                  style={{
                    color: "#d32f2f",
                    fontSize: 12,
                    marginTop: 8,
                    textAlign: "center",
                  }}
                >
                  {importFormik.errors.file}
                </div>
              )}
            </div>
          </form>
        </div>
        <div className="modal_footer">
          <button
            type="button"
            onClick={handleCancel}
            className="btn btn-border"
          >
            Cancel
          </button>
          <button
            type="submit"
            onClick={importFormik.handleSubmit}
            disabled={!selectedFile || importFormik.isSubmitting}
            className="btn btn-primary"
          >
            {importFormik.isSubmitting ? "Importing..." : "Import"}
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default RoomLogImportModal;
